<div *ngIf="data; else Loading" class="row">
  <div class="col-12 table-responsive gung-responsive">
    <table class="table table-striped">
      <thead>
        <tr>
          <th translate>CUSTOMER_ID</th>
          <th translate>CUSTOMER_NAME</th>
          <th translate>TIRE_TYPE</th>
          <th translate>AXLE</th>
          <th translate>SEASON</th>
          <th translate>DIMENSION</th>
          <th translate>BRAND</th>
          <th translate>TREAD_PATTERN</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td [attr.data-label]="'CUSTOMER_ID' | translate">{{ item.customerId }}</td>
          <td [attr.data-label]="'CUSTOMER_NAME' | translate">{{ item.customerName }}</td>
          <td [attr.data-label]="'TIRE_TYPE' | translate">{{ item.tireType }}</td>
          <td [attr.data-label]="'AXLE' | translate">{{ item.tireAxle }}</td>
          <td [attr.data-label]="'SEASON' | translate">{{ item.season }}</td>
          <td [attr.data-label]="'DIMENSION' | translate">{{ item.measures }}</td>
          <td [attr.data-label]="'BRAND' | translate">{{ item.supplierName }}</td>
          <td [attr.data-label]="'TREAD_PATTERN' | translate">{{ item.treadPattern }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #Loading>
  <div class="d-flex justify-content-center w-100 mb-4">
    <i class="fa fa-spinner fa-spin fa-5x"></i>
  </div>
</ng-template>
